import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getProtocol.success: {
            return action.payload;
        }

        case constants.getProtocol.try: {
            return initialState;
        }

        default:
            return state;
    }
}
